import React from "react";
import { Carousel, Image } from "react-bootstrap";

const CarouselComponent: React.FC = () => {
    return(
        <Carousel
            fade
            interval={6000}
            controls={true}
            indicators={true}
            pause={false} // esto es clave
            slide={true}
            className="pb-5">
            <Carousel.Item><img className="d-block w-100" src="/images/banner2R.png" /></Carousel.Item>
            <Carousel.Item><img className="d-block w-100" src="/images/RIUDICC25.png" /></Carousel.Item>
        </Carousel>
    )
}

export default CarouselComponent;